import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import { PLAYER_NUMBER } from "../../../pages/GamePlay/types";
import ImageComponent from "../../ImageComponent";
import { TOKEN_MOVE_LONG_STEP_TIME, TOKEN_MOVE_STEP_TIME } from "../constant";

interface IKukariMoveAnimationProps {
  kukariImage: string;
  glowImage?: string;
  height: number;
  width: number;
  currentCoordinates?: { translateX: number; translateY: number };
  nextCoordinates?: { translateX: number; translateY: number };
  isLongStep: boolean;
  moveKukari: () => void;
  opacity: number;
  stepScore: number;
  playerNumber: PLAYER_NUMBER;
}

const KukariMoveAnimation: React.FC<IKukariMoveAnimationProps> = ({
  currentCoordinates,
  nextCoordinates,
  kukariImage,
  height,
  width,
  isLongStep,
  moveKukari,
  opacity,
}) => {
  const kukariRef = useRef<HTMLDivElement>(null);
  const [transformStyle, setTransformStyle] = useState({
    translateX: currentCoordinates?.translateX || 0,
    translateY: currentCoordinates?.translateY || 0,
  });

  useEffect(() => {
    if (nextCoordinates) {
      // Update style for transition
      setTransformStyle({
        translateX: nextCoordinates.translateX,
        translateY: nextCoordinates.translateY,
      });

      const animationDuration = isLongStep ? TOKEN_MOVE_LONG_STEP_TIME : TOKEN_MOVE_STEP_TIME;

      // Trigger moveKukari callback after animation ends
      const timeoutId = setTimeout(moveKukari, animationDuration);
      return () => clearTimeout(timeoutId);
    }
  }, [nextCoordinates, isLongStep, moveKukari]);

  if (!currentCoordinates || !nextCoordinates) {
    return null;
  }

  return (
    <div
      ref={kukariRef}
      className={styles.kukariContainer}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        opacity: opacity,
        transform: `translate(${transformStyle.translateX}px, ${transformStyle.translateY}px)`,
        // transition: `transform ${isLongStep ? 0.8 : 0.4}s linear`,
      }}
    >
      <div className={styles.kukariImageWrapper}>
        <ImageComponent
          src={kukariImage}
          alt="kukari"
          style={{
            height: `${height}px`,
            width: `${width}px`,
          }}
          className={styles.kukariImage}
        />
      </div>
    </div>
  );
};

export default KukariMoveAnimation;
